import { observer } from 'mobx-react';
import React from 'react';

import useStores from 'hooks/use-stores';
import StatisticWidget from 'pages/Search/components/Database/components/StatisticWidget';
import { WidgetCVEProgression, WidgetTweets } from 'pages/stats/total/Widgets';

import useStyles from './styles';

const Widgets = () => {
    const { classes } = useStyles();
    const { statsStore } = useStores();
    const { statsLoading: loading, stats, types } = statsStore;
    const {
        bulletins,
        collections,
        avgExploitPublicationDate,
        avgWildExploitPublished,
        exploits,
        avgCvssScore,
        avgCvePerDay,
        avgBulletinsPerDay
    } = stats;

    return (
        <div className={classes.container}>
            <WidgetCVEProgression className={classes.progression} />
            <WidgetTweets hideFullList className={classes.social} />
            <StatisticWidget
                loading={loading}
                value={bulletins > 999999 ? (bulletins / 1000000).toFixed() + 'mln +' : bulletins}
                description={'Security advisories and articles'}
                href={'/search?query=type:*'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={Number(collections) || Object.keys(types || {}).length || 0}
                description={'Software vendors and other security sources'}
                href={'/search?query=type:cve'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(avgExploitPublicationDate / (60 * 60)).toFixed() + 'h'}
                description={'Average hours to exploit published'}
                href={'/search?query=bulletinFamily:exploit last 7 days'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(avgWildExploitPublished / (60 * 60 * 24)).toFixed() + 'd'}
                description={'Average days to cve exploited in the wild'}
                href={'/search?query=enchantments.exploitation.wildExploited:true'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(exploits / 1000).toFixed() + 'k +'}
                description={'Exploits for popular software and systems'}
                href={'/search?query=bulletinFamily:exploit'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(avgCvssScore || 0).toFixed(2)}
                description={'Average CVSS score from beginning of time'}
                href={'/search?query=cvss.score:10'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(avgCvePerDay || 0).toFixed(0)}
                description={'Average CVE released per day'}
                href={'/search?query=type:cve last 1 days'}
                className={classes.counter}
            />
            <StatisticWidget
                loading={loading}
                value={(avgBulletinsPerDay || 0).toFixed(0)}
                description={'Average Entries added per day'}
                href={'/search?query=order:published last 1 days'}
                className={classes.counter}
            />
        </div>
    );
};

export default observer(Widgets);
